<template>
    <el-button type="info" :size="size" @click="doExport">
        <i class="fa fa-file-text"></i>&nbsp;<slot></slot></el-button>
</template>
<script>
    /**
    * 导出筛选结果
    * @author zjs
    * @time 2017.10.31
    */
    export default {
        name: 'LyButtonExport',
        props: {
            size: {
                type: String,
                default: 'small'
            },
            ticket: {
                type: String,
                default: ''
            },
            formdata: {
                type: [Object, Array],
                default: () => {}
            }
        },
        methods: {
            /**
             * 进行数据导出
             */
            doExport () {
                this.formdata['ticket'] = this.ticket
                 this.$api.export.create(this.formdata).then((rs) => { // 正确请求成功时处理  
                    this.$alert('查询任务已提交，请前往查询下载中心下载计算完毕的数据', '提示信息', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        showCancelButton: true,
                        type: 'success'
                    }).then(() => {
                        this.$router.push({name: 'download'})
                    }, () => {})
                }).catch((error) => { // 捕捉错误处理  
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            }
        }
    }
</script>